const t = {
  fromAttribute(r) {
    return r == null ? !1 : r === "" || r === "true" || r === !0 ? !0 : r === "false" || r === !1 ? !1 : !!r;
  },
  toAttribute(r) {
    return r ? "true" : "false";
  }
};
export {
  t as b
};
